export const actionTypes = {
    CLEAR_STORE: 'powertrainWizardV2/CLEAR_STORE',
    SET_WIZARD_STEP_STATE: 'powertrainWizardV2/SET_WIZARD_STEP_STATE',
    SET_WIZARD_ACTIVE_STEP: 'powertrainWizardV2/SET_WIZARD_ACTIVE_STEP',
    GET_AVAILABLE_ASSETS: 'powertrainWizardV2/GET_AVAILABLE_ASSETS',
    SET_SELECTED_POWERTRAIN_NAME: 'powertrainWizardV2/SET_SELECTED_POWERTRAIN_NAME',
    SET_SELECTED_SITE: 'powertrainWizardV2/SET_SELECTED_SITE',
    SET_SELECTED_ASSET_TYPE_AVAILABLE_SECTION: 'powertrainWizardV2/SET_SELECTED_ASSET_TYPE_AVAILABLE_SECTION',
    SET_ASSET_FILTER_AVAILABLE_SECTION: 'powertrainWizardV2/SET_ASSET_FILTER_AVAILABLE_SECTION',
    SET_SELECTED_ASSET_TYPE_ADDED_SECTION: 'powertrainWizardV2/SET_SELECTED_ASSET_TYPE_ADDED_SECTION',
    SET_ASSET_FILTER_ADDED_SECTION: 'powertrainWizardV2/SET_ASSET_FILTER_ADDED_SECTION',
    ADD_ASSET: 'powertrainWizardV2/ADD_ASSET',
    REMOVE_ASSET: 'powertrainWizardV2/REMOVE_ASSET',
    ADD_POWERTRAIN: 'powertrainWizardV2/ADD_POWERTRAIN',
    ADD_POWERTRAIN_SUCCESS: 'powertrainWizardV2/ADD_POWERTRAIN_SUCCESS',
    ADD_POWERTRAIN_FAILURE: 'powertrainWizardV2/ADD_POWERTRAIN_FAILURE',
    SET_POWERTRAIN_FOR_EDITING: 'powertrainWizardV2/SET_POWERTRAIN_FOR_EDITING',
    EDIT_POWERTRAIN: 'powertrainWizardV2/EDIT_POWERTRAIN',
    EDIT_POWERTRAIN_SUCCESS: 'powertrainWizardV2/EDIT_POWERTRAIN_SUCCESS',
    EDIT_POWERTRAIN_FAILURE: 'powertrainWizardV2/EDIT_POWERTRAIN_FAILURE',
    GET_ASSET_DETAILS: 'powertrainWizardV2/GET_ASSET_DETAILS',
    GET_ASSET_SUB_TYPES: 'powertrainWizardV2/GET_ASSET_SUB_TYPES',
    SET_SELECTED_POWERTRAIN: 'powertrainTools/SET_SELECTED_POWERTRAIN',

    //saga
    ADD_POWERTRAIN_REQUEST: 'powertrainWizardV2/ADD_POWERTRAIN_REQUEST',
    EDIT_POWERTRAIN_REQUEST: 'powertrainWizardV2/EDIT_POWERTRAIN_REQUEST',
    GET_AVAILABLE_ASSETS_REQUEST: 'powertrainWizardV2/GET_AVAILABLE_ASSETS_REQUEST',
    GET_ASSET_DETAILS_REQUEST: 'powertrainWizardV2/GET_ASSET_DETAILS_REQUEST',
    GET_ASSET_SUB_TYPES_REQUEST: 'powertrainWizardV2/GET_ASSET_SUB_TYPES_REQUEST',
};

export const operations = {
    ADD: 'ADD',
    REMOVE: 'REMOVE'
};

export const wizardSteps = {
    STEP1: 'STEP1',
    STEP2: 'STEP2',
    STEP3: 'STEP3'
};

export const wizardStepStates = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    COMPLETED: 'completed',
};

export const MAX_LENGTH_POWERTRAIN_NAME = 100;

export const WIZARD_MODES = {
    EDIT: 'edit',
};

export const WIZARD_STEP_KEYS = {
    BASIC_INFO: 'basicInfo',
    ASSET_SELECTION: 'assetSelection',
    PHYSICAL_CONNECTION: 'physicalConnection',
    REVIEW: 'review',
    METADATA: 'metadata',
};

export const DEFAULT_WIZARD_CONFIG = {
    steps: [
        { id: wizardSteps.STEP1, key: 'basicInfo', title: 'Basic Info', isRequired: true },
        { id: wizardSteps.STEP2, key: 'assetSelection', title: 'Asset Selection', isRequired: false },
        { id: wizardSteps.STEP3, key: 'preview', title: 'Preview', isRequired: false }
    ],
    activeStep: wizardSteps.STEP1
};

export const pageSize = 10000;

// Validation Constants
export const VALIDATION_CONSTANTS = {
    MAX_POWERTRAIN_NAME_LENGTH: 100,
    MAX_DESCRIPTION_LENGTH: 500,
    MAX_SELECTED_ASSETS: 50
};

export const UNMONITORED_GEARBOX_TYPE_CONFIG_ID = 'abb.smartsensor.asset.GenericMachine@1';

// Asset Type Constants
export const ASSET_TYPES = {
    MOTOR: 'motor',
    GEARBOX: 'gearbox'
};

// Wizard Mode Constants
export const wizardModes = {
    EDIT: 'edit',
    CREATE: 'create'
};

// Form field names
export const formFieldNames = {
    REVIEW: 'review',
    NAME: 'name',
    POWERTRAIN_NAME: 'powertrainName',
    SITE: 'site',
    LOCATION: 'location',
    SELECTED_LOCATION: 'selectedLocation',
    ADDED_ASSETS: 'addedAssets'
};
